export default "__VITE_ASSET__Dlzl9TCK__"